import { Content } from "@/components/Global/Content";
import { cx } from "@/lib/style/cva.config";

export function AuthContent({
	parts,
	...props
}: React.ComponentProps<typeof Content> & {
	parts?: { container?: React.ComponentPropsWithoutRef<"div"> };
}) {
	return (
		<Content fullscreen {...props}>
			<div
				{...parts?.container}
				className={cx(
					"plt-desktop:max-w-sm mx-auto flex w-full flex-1 flex-col gap-6",
					parts?.container?.className,
				)}
			>
				{props.children}
			</div>
		</Content>
	);
}
